import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { VUE_DIALOG_CONFIG } from 'vue/utilities/vue-dialog-config';

/**
 *  Component for removing an individual template
 */
@Component({
    selector: 'app-confirmation-modal',
    templateUrl: './confirmation-modal.component.html',
    standalone: false
})
export class ConfirmationModalComponent {
  public constructor(
  // eslint-disable-next-line @typescript-eslint/no-parameter-properties
    @Inject(MAT_DIALOG_DATA) public data: ConfirmationModalInputs,
    private dialogRef: MatDialogRef<ConfirmationModalComponent>
  ) {}

  public closeDialog(): void {
    this.dialogRef.close();
  }

  public action(): void {
    this.data.actionCallback();
    this.closeDialog();
  }
}

export const confirmationModalConfig = {
  ...VUE_DIALOG_CONFIG,
};

export interface ConfirmationModalInputs {

  /**
   * Title shown on top of dialog
   */
  title: Observable<string>;

  message: Observable<string>;

  confirmationType: string;

  /**
   * Callback used when remove is chosen by the user
   */
  actionCallback: () => void;
}
